"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const api_constants_1 = require("@ib/api-constants");
const isUsedAsDecorator_1 = require("./isUsedAsDecorator");
function handlePromiseBind(promise, observableTarget, observableKey, callback, isPaginationEnabled = false, limit = 0, dataKey, options = { loadingStatus: api_constants_1.API_FETCHING }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { loadingStatus } = options;
        const observableProperty = observableKey
            ? observableTarget[observableKey]
            : observableTarget;
        observableProperty.promiseState = loadingStatus || api_constants_1.API_FETCHING;
        try {
            const data = yield promise;
            if (isPaginationEnabled) {
                if ((dataKey === undefined || dataKey === null || dataKey === '') &&
                    Array.isArray(data) &&
                    data.length < limit) {
                    observableProperty.promiseState = api_constants_1.API_PAGINATION_FINISHED;
                }
                else if (Array.isArray(data[dataKey]) &&
                    data[dataKey].length < limit) {
                    observableProperty.promiseState = api_constants_1.API_PAGINATION_FINISHED;
                }
                else {
                    observableProperty.promiseState = api_constants_1.API_SUCCESS;
                }
            }
            else {
                observableProperty.promiseState = api_constants_1.API_SUCCESS;
            }
            observableProperty.data = callback
                ? callback(data, observableProperty.data)
                : data;
            return data;
        }
        catch (e) {
            observableProperty.data = null;
            observableProperty.promiseState = api_constants_1.API_FAILED;
        }
        finally {
        }
        return promise
            .then(() => { })
            .catch(mobx_1.action('reject-promise', err => {
            observableProperty.promiseState = api_constants_1.API_FAILED;
            return Promise.reject(err);
        }));
    });
}
function handlePromiseBindWithOnSuccess(promise, updateLoadingStatus, onSuccess, isPaginationEnabled = false, limit = 0, dataKey, options = { loadingStatus: api_constants_1.API_FETCHING }) {
    const { loadingStatus } = options;
    updateLoadingStatus(loadingStatus || api_constants_1.API_FETCHING);
    return promise
        .then(mobx_1.action('fulfill-promise', (data) => __awaiter(this, void 0, void 0, function* () {
        const successResponse = onSuccess(data);
        yield successResponse;
        if (isPaginationEnabled === true) {
            if ((dataKey === undefined || dataKey === null || dataKey === '') &&
                Array.isArray(data) &&
                data.length < limit) {
                updateLoadingStatus(api_constants_1.API_PAGINATION_FINISHED);
            }
            else if (Array.isArray(data[dataKey]) &&
                data[dataKey].length < limit) {
                updateLoadingStatus(api_constants_1.API_PAGINATION_FINISHED);
            }
            else {
                updateLoadingStatus(api_constants_1.API_SUCCESS);
            }
        }
        else {
            updateLoadingStatus(api_constants_1.API_SUCCESS);
        }
        return data;
    })))
        .catch(mobx_1.action('reject-promise', (err) => {
        updateLoadingStatus(api_constants_1.API_FAILED);
        return Promise.reject(err.message);
    }));
}
function bindPromiseTo(observablePropertyKey) {
    return (...args) => {
        if (!isUsedAsDecorator_1.default(args)) {
            throw new Error("`bindPromiseTo` is supposed to be used as a decorator. You don't seem to using it as such.");
        }
        const [target, descriptor] = args;
        const fn = descriptor.value;
        target[observablePropertyKey].data = target[observablePropertyKey].data;
        const newFn = function (...newArgs) {
            const promise = fn.apply(this, newArgs);
            return handlePromiseBind(promise, target, observablePropertyKey);
        };
        descriptor.value = newFn;
        return descriptor;
    };
}
exports.bindPromiseTo = bindPromiseTo;
function bindPromise(promise) {
    return {
        to: (observableProperty, callback, isPaginationEnabled, limit, dataKey) => handlePromiseBind(promise, observableProperty, null, callback, isPaginationEnabled, limit, dataKey)
    };
}
exports.bindPromise = bindPromise;
function bindPromiseWithOnSuccess(promise, options = { loadingStatus: api_constants_1.API_FETCHING }) {
    return {
        to: (updateLoadingStatus, onSuccess, isPaginationEnabled, limit, dataKey) => handlePromiseBindWithOnSuccess(promise, updateLoadingStatus, onSuccess, isPaginationEnabled, limit, dataKey, options)
    };
}
exports.bindPromiseWithOnSuccess = bindPromiseWithOnSuccess;
//# sourceMappingURL=index.js.map